import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { toast, Toaster, ToastBar } from "react-hot-toast";

function useMedia(query) {
  if (typeof window === "undefined") {
    return null;
  }
  const [matches, setMatches] = useState(window.matchMedia(query).matches);

  useEffect(() => {
    const media = window.matchMedia(query);
    if (media.matches !== matches) {
      setMatches(media.matches);
    }
    const listener = () => setMatches(media.matches);
    media.addEventListener("change", listener);
    return () => media.removeEventListener("change", listener);
  }, [query, matches]);

  return matches;
}

export function notificationContent(title = "", text = "") {
  return (
    <div className="flex w-full flex-col">
      <p className="text-sm font-medium text-text-primary">{title}</p>
      <p className="mt-1 text-sm text-text-secondary">{text}</p>
    </div>
  );
}

export const hotToast = toast;

function NotificationToaster() {
  const smallScreenWidth = useMedia("(max-width: 640px)");

  return (
    <Toaster
      position={smallScreenWidth ? "top-center" : "bottom-right"}
      toastOptions={{
        className: "bg-background-white ring-1 ring-ring-black ring-opacity-5",
        duration: 10000,
        style: {
          borderRadius: "0.5rem",
          maxWidth: "24rem",
          width: "100%",
          overflow: "hidden",
        },
        success: {
          duration: 3000,
        },
        error: {
          duration: 5000,
        },
      }}
    >
      {(t) => (
        <ToastBar toast={t}>
          {({ icon, message }) => (
            <>
              {icon}
              {message}
            </>
          )}
        </ToastBar>
      )}
    </Toaster>
  );
}

NotificationToaster.propTypes = {
  data: PropTypes.object,
};

export default NotificationToaster;
